import {
  FETCH_PLATFORMS_START,
  FETCH_PLATFORMS_SUCCESS,
  FETCH_PLATFORMS_ERROR,
  CREATE_PLATFORM_START,
  CREATE_PLATFORM_SUCCESS,
  CREATE_PLATFORM_ERROR,
  DELETE_PLATFORM_START,
  DELETE_PLATFORM_SUCCESS,
  DELETE_PLATFORM_ERROR,
  UPDATE_PLATFORM_START,
  UPDATE_PLATFORM_ERROR,
  UPDATE_PLATFORM_SUCCESS,
} from "./platforms.types";

// Platforms actions
export const fetchPlatformsStart = () => ({
  type: FETCH_PLATFORMS_START,
});
export const fetchPlatformsSuccess = (data) => ({
  type: FETCH_PLATFORMS_SUCCESS,
  payload: data,
});
export const fetchPlatformsError = (error) => ({
  type: FETCH_PLATFORMS_ERROR,
  payload: error,
});

// Single platform actions
export const createPlatformStart = (platform) => ({
  type: CREATE_PLATFORM_START,
  payload: platform,
});

export const createPlatformSuccess = (platform) => ({
  type: CREATE_PLATFORM_SUCCESS,
  payload: platform,
});

export const createPlatformError = (platform) => ({
  type: CREATE_PLATFORM_ERROR,
  payload: platform,
});

export const updatePlatformStart = (platform) => ({
  type: UPDATE_PLATFORM_START,
  payload: platform,
});

export const updatePlatformSuccess = (platform) => ({
  type: UPDATE_PLATFORM_SUCCESS,
  payload: platform,
});

export const updatePlatformError = (platform) => ({
  type: UPDATE_PLATFORM_ERROR,
  payload: platform,
});

export const deletePlatformStart = (platform) => ({
  type: DELETE_PLATFORM_START,
  payload: platform,
});

export const deletePlatformSuccess = (data) => ({
  type: DELETE_PLATFORM_SUCCESS,
  payload: data,
});

export const deletePlatformError = (error) => ({
  type: DELETE_PLATFORM_ERROR,
  payload: error,
});
